<template>
  <div v-if="shouldShowResultsCounter" class="heading-3 break-words">
    {{ i18n(translations.title, { count, search }) }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './ResultsCounter.translations'

const i18n = useI18n()

const props = defineProps<{ search?: string; count: number }>()
const shouldShowResultsCounter = computed(() => Boolean(props.search?.length))
</script>
